import classNames from "classnames"
import jailOverlayImage from "@/images/jail-overlay.svg"
import { useState } from "react"
import Chance from "./Chance"
import { mapDesigns } from "@mono/mapDesigns"
import { images } from "@/utils/data"

interface BonusCardFrontProps {
  type: BonusCardType
  card: IBonusCard
  className?: string
}
export const BonusCardFront: React.FC<BonusCardFrontProps> = ({
  type,
  card,
  className,
}) => {
  return (
    <div className={`bg-white p-2 h-52 w-80 md:h-44 md:w-72 z-30 ${className}`}>
      Hello world
      <img
        className="w-full h-full object-cover"
        src={images.cards["perform-tax-audit"]}
        alt="Bonus Card Front"
      />
      {/* <div className="flex items-center justify-around flex-col h-full w-full border-black border relative">
        <div
          className={classNames(
            "text-chest-back font-poppins font-medium absolute top-0 left-1/2 bg-white  -translate-y-1/2 -translate-x-1/2 text-[12px] md:text-[10px] px-1 ",
            { "text-chance-back": type === "chance" }
          )}
        >
          {type === "chance" ? "Chance" : "Community chest"}
        </div> */}
      {/* <div className="relative w-full flex justify-center"> */}
      {/*   <div className="bg-chest-back text-white font-poppins  w-4/5 text-center text-[11px]  px-5 "> */}
      {/*     Community chest */}
      {/*   </div> */}
      {/**/}
      {/*   <img */}
      {/*     src={monopolyMan} */}
      {/*     className="h-6 absolute top-0 left-1/2 -translate-x-1/2 -translate-y-3/4" */}
      {/*   /> */}
      {/* </div> */}
      {/* <p className="font-primary text-center text-sm md:text-xs text-black">
          {card.text}
        </p>
        <div className="text-[12px] md:text-[10px] text-black font-poppins absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 bg-white px-1">
          Monopoly
        </div>
      </div> */}
    </div>
  )
}
